import { StepKey } from "@/src/lib/workflows/steps/types";
import { type TaskStep, TaskStepStatus } from "@/src/models/task-step";

export function isTprEligibilityTimeoutReview(step: TaskStep): boolean {
  return (
    step.stepKey === StepKey.SUBMIT_ATHENA_INSURANCE_ELIGIBILITY &&
    step.status === TaskStepStatus.COMPLETED &&
    step.output?.outcome === "unknown" &&
    step.output?.reviewReason === "polling_timeout"
  );
}

/** Eligibility needs an Athena result; manual continuation must rerun it rather than skip it. */
export function resolveTprManualStepContinuation(step: TaskStep): Pick<TaskStep, "status" | "output"> {
  if (step.stepKey === StepKey.SUBMIT_ATHENA_INSURANCE_ELIGIBILITY) {
    // PAUSED resumes at this step. Clear the old polling window so a timed-out check can start fresh.
    return { status: TaskStepStatus.PAUSED, output: null };
  }

  return {
    status: TaskStepStatus.COMPLETED,
    output:
      step.stepKey === StepKey.CREATE_COVERAGE ? { ...(step.output ?? {}), manuallyCompleted: true } : step.output,
  };
}
